import React from 'react';
import { Box, useResponsive } from '@common-fe/common-fe';

import { AuthorizedUser, CreateAuthorizedUserParams, UpdateAuthorizedUserParams } from '../authorizedUsers.types';

import AuthorizedUsersHeader from './AuthorizedUsersHeader';
import AuthorizedUsersList from './AuthorizedUsersList';
import AuthorizedUsersModal from './AuthorizedUsersModal';
import DeactivateAuthorizedUserModal from './DeactivateAuthorizedUserModal';

export interface AuthorizedUsersProps {
  authorizedUsers: AuthorizedUser[];
  isLoading: boolean;
  isModalOpen: boolean;
  editingUser: AuthorizedUser | null;
  deactivatingUserId: string | null;
  isSubmitting: boolean;
  isDeactivating: boolean;
  onAddNew: () => void;
  onEdit: (user: AuthorizedUser) => void;
  onDeactivate: (id: string) => void;
  onCreate: (params: CreateAuthorizedUserParams) => void;
  onUpdate: (params: UpdateAuthorizedUserParams) => void;
  onConfirmDeactivate: () => void;
  onCloseModal: () => void;
  onCloseDeactivateModal: () => void;
}

const AuthorizedUsers = ({
  authorizedUsers,
  isLoading,
  isModalOpen,
  editingUser,
  deactivatingUserId,
  isSubmitting,
  isDeactivating,
  onAddNew,
  onEdit,
  onDeactivate,
  onCreate,
  onUpdate,
  onConfirmDeactivate,
  onCloseModal,
  onCloseDeactivateModal,
}: AuthorizedUsersProps) => {
  const { isMobile } = useResponsive();
  const pad = isMobile ? 'spacing16' : 'spacing24';

  return (
  <>
    <Box round="moduleRound" pad={pad} background="module" data-testid="authorized-users">
      <Box
        round="container1Round"
        border={{ color: 'border2', size: '1px' }}
        background="canvas"
        pad={pad}
      >
        <AuthorizedUsersHeader onAddNew={onAddNew} />
        <AuthorizedUsersList
          authorizedUsers={authorizedUsers}
          isLoading={isLoading}
          onEdit={onEdit}
          onDeactivate={onDeactivate}
        />
      </Box>
    </Box>

    {isModalOpen && (
      <AuthorizedUsersModal
        editingUser={editingUser}
        isSubmitting={isSubmitting}
        onCreate={onCreate}
        onUpdate={onUpdate}
        onClose={onCloseModal}
      />
    )}

    {deactivatingUserId && (
      <DeactivateAuthorizedUserModal
        isDeactivating={isDeactivating}
        onConfirm={onConfirmDeactivate}
        onClose={onCloseDeactivateModal}
      />
    )}
  </>
  );
};

export default AuthorizedUsers;
